import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { IFailedTransaction } from "@pbm/transactions/contracts/failed-transaction";
import { usePbm2Url } from "@common/hooks/usePbm2Url";

export function useFailedTransaction(id: string) {
  const { request } = usePbm2Url();
  return useQuery(`failedTransactions:${id}`, async () => {
    const {
      Transactional_failedTransactions: { edges },
    } = await request(
      gql`
        query failedTransactions(
          $filter: Transactional_FailedTransactionArgsFilterInput
        ) {
          Transactional_failedTransactions(filter: $filter) {
            edges {
              node {
                id
                storeCode
                customerCode
                beneficiary {
                  id
                }
                grossValue
                discountValue
                netValue
                statusCode
                statusMessage
                origin
                createdAt
                type
                authorizationNumber
                sequenceNumber
                items {
                  programCode
                  statusCode
                  statusMessage
                  ean
                  quantity
                  unitGrossValue
                  unitDiscountValue
                  unitNetValue
                  grossValue
                  discountValue
                  netValue
                  discountPercentage
                  storageUrl
                  prescribedAt
                  prescribedQuantity
                  prescriber {
                    council
                    registerNumber
                    stateAbbr
                  }
                }
              }
            }
          }
        }
      `,
      { filter: { id: [id] } }
    );
    return (
      (edges || []).map(
        ({ node }: { node: IFailedTransaction }) => node
      ) as IFailedTransaction[]
    )[0];
  });
}
